import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core'
import { AuthService, RestServices } from '@app/services'
import { notification } from 'onsenui'
import { Subscription } from 'rxjs'

@Component({
    selector: 'app-upload-file',
    templateUrl: './upload-file.component.html',
    styleUrls: ['./upload-file.component.css'],
})
export class UploadFileComponent implements OnInit, OnDestroy {
    @Input() type = 'image'
    @Input() index = 0
    @Input() isMultiple = false
    @Input() forMobile = false
    @Input() withLoading = false
    @Input() maxSize = 256 // MB

    @Input() locale: any
    @Output() _onBrowser: EventEmitter<any> = new EventEmitter()
    @Output() _onUploaded: EventEmitter<any> = new EventEmitter()

    @ViewChild('inputUpload') inputUpload: ElementRef

    base64: any
    loading: boolean
    public acceptType = ''
    private subscriptions: Subscription[] = []

    constructor(private authData: AuthService, private restApi: RestServices) {
    }

    ngOnInit() {
        console.debug('ngOnInit')
        switch (this.type) {
            case 'image':
                this.acceptType = 'image/*'
                break
            case 'video':
                this.acceptType = 'video/*'
                break
            case 'pdf':
                this.acceptType = 'application/pdf'
                break
            default:
                // default is allow all
                return '*/*'
        }
        if (!this.locale) {
            this.locale = this.authData.getLocale()
        }
    }

    ngOnDestroy(): void {
        if(this.subscriptions){
            this.subscriptions.forEach((s) => s.unsubscribe())
        }
    }

    private checkMimeType(file) {
        switch (this.type) {
            case 'image':
                return (
                    file['type'] === 'image/jpeg' ||
                    file['type'] === 'image/png' || file['type'] === 'image/tiff'
                )
            case 'video':
                return file['type'].search('video/') > -1
            case 'pdf':
                return file['type'] === 'application/pdf'
            default:
                // default is allow all
                return true
        }
    }

    // 256MB
    checkMaxSizeUpload(file) {
        console.debug('check file size')
        if (parseInt(file['size']) / 1024 / 1024 > this.maxSize) {
            this.showError(this.locale['communication-video-max-upload-size-exceeded'])
            $('#inputUpload0').val('')
            return false
        } else {
            return true
        }
    }

    private showError(message) {
        notification.confirm({
            message: message,
            title: '<b>' + this.locale['alert-title'] + '</b>',
            cancelable: false,
            buttonLabels: ['OK'],
        })
    }

    startChooseFile(event) {
        this._onBrowser.emit({ index: this.index })
    }

    handleFileInput(event) {
        console.debug('start handleFileInput', event)

        const files: FileList = event.target.files
        if (files && files[0]) {
            this.authData.authToken().then((tokenReNew) => {
                let idx
                const fileCount = files.length
                for (idx = 0; idx < fileCount; idx++) {
                    const file = files[idx]
                    if (
                        file &&
                        this.checkMimeType(file) &&
                        this.checkMaxSizeUpload(file)

                    ) {
                        this.loading = true
                        let reader = new FileReader()
                        reader.readAsDataURL(file) // read file as data url

                        reader.onload = (event: any) => {
                            // called once readAsDataURL is completed
                            this.base64 = event.target.result
                        }
                        this.subscriptions.push(
                            this.restApi
                            .postFile(file, tokenReNew)
                            .subscribe((success) => {
                                const hashUrl = success['hash']
                                const mime = success['mime']
                                const uploadData = {
                                    id: hashUrl,
                                    mime: mime,
                                    matrix: [1, 0, 0, 1],
                                    name: file.name,
                                    base64: this.base64,
                                    index: this.index,
                                }
                                this.resetForm()
                                this._onUploaded.emit(uploadData)
                            }, error => {
                                console.error(error)
                                this.resetForm()
                                if (error.status === 413) {
                                    this.showError(this.locale['communication-video-max-upload-size-exceeded'])
                                } else {
                                    this.showError(error.statusText)
                                }
                            }),
                        )
                        this.index++
                    }
                }
            })
        }
    }

    cancelUpload() {
        console.log('cancelUpload')
        this.resetForm()
        this.subscriptions.forEach((subscription) => {
            subscription.unsubscribe()
        })
    }

    resetForm() {
        this.inputUpload.nativeElement.value = ''
        this.loading = false
    }
}



// WEBPACK FOOTER //
// ./src/app/commons/upload-file/upload-file.component.ts